




























































































































































































































import Vue from "vue";
import Spinner from "@/components/Spinner.vue";
import Processing from "./Processing.vue";
import Popup from "@/components/Popup.vue";
import AppTableRow from "./AppTableRow.vue";
import { ITableConfig, IColumn } from "./table.model";
import { SORTING_DIR } from "@/common/models";
import {
  computed,
  Ref,
  ref,
  watch,
  onBeforeUnmount,
  onMounted,
} from "@vue/composition-api";
import { debounce, pluck, toRecord, emptyFn } from "@/fp";
import VScroller from "./VScroller.vue";
import ExportCsvPopupVue from "./ExportCsvPopup.vue";
import { UsePopup } from "../root/popup/popup.state";
import { remToPx } from "@/common/dom.functions";
import { AppAnalytics } from "@/analytics";
import ThemeImg from "../ThemeImg.vue";
export default Vue.extend({
  components: {
    Popup,
    Spinner,
    Processing,
    VScroller,
    ThemeImg,
  },
  props: {
    keepConstWidth: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      required: true,
    },
    loader_text: {
      type: String,
      default: "Loading Results",
    },
    hasTableSummary: {
      type: Boolean,
      default: false,
    },
    tableSummaryLabel: {
      type: String,
      default: "Table Summary",
    },
    csvExportEnable: {
      type: Boolean,
      default: true,
    },
    descFooter: {
      type: String,
      default: "",
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
    items: {
      type: Array,
      required: true,
    },
    noResults: {
      type: Boolean,
      default: false,
    },
    showingExtraText: {
      type: String,
      default: "",
    },
    noResultsText: {
      type: String,
      default: "No Results",
    },
    total: {
      type: Number,
      default: 0,
    },
    featureCsv: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: true,
    },
    selectedId: {
      type: [Number, String],
      default: -1,
    },
    cmp: {
      type: Function,
    },
    itemHeightRem: {
      type: Number,
      default: 3.75,
    },
    common_row_data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  setup(props, { emit, root: { $route } }) {
    const theTable: Ref<HTMLDivElement | null> = ref(null);
    const isSummaryOpen = ref(false);
    const showNoResults = computed(
      () =>
        props.isLoading === false &&
        // @ts-ignore
        props.items.length === 0
    );

    const _config: Ref<ITableConfig> = computed(
      () => props.config as ITableConfig
    );

    const keys = computed(() => _config.value.columns.map((c) => c.key));

    const gridCols = computed(() =>
      _config.value.columns.reduce(
        (acc, col) => (acc += `minmax(${col.spanMin},${col.spanMax}) `),
        ""
      )
    );

    /**
     * @public
     *  */

    const reposition = () => {
      // @ts-ignore
      psb && psb.value && psb.value.rePosition && psb.value.rePosition();
    };

    const tableRow = computed(() => {
      return props.cmp ? props.cmp : AppTableRow;
    });

    const displayItems = computed(() =>
      (props.items as { __id: number }[]).map((item) => {
        return {
          ...item,
          gridCols: gridCols.value,
          selected: item.__id === props.selectedId,
          keys: keys.value,
        };
      })
    );

    const minTableWidth = computed(() =>
      _config.value.columns.reduce((acc, col) => {
        acc += Number.parseFloat(col.spanMin);
        return acc;
      }, 0)
    );

    const loadMore = debounce(200)(() => {
      if (!props.isLoading) {
        emit("loadMore");
      }
    });

    const psb: Ref<Vue | null> = ref(null);
    // sort table by the given key
    const sort = (col: IColumn) => {
      const { sortDir, key } = col;
      const dir =
        sortDir === SORTING_DIR.ASC ? SORTING_DIR.DESC : SORTING_DIR.ASC;
      emit("sort", { dir, key });
    };

    const exportAsCsv = async (event: MouseEvent) => {
      // @ts-ignore
      if (props.items.length > 0 && props.csvExportEnable && props.featureCsv) {
        const res = await UsePopup.showActionPopup({
          type: "CustomDisplayPopup",
          preventOnScrollClose: true,
          cmp: ExportCsvPopupVue,
          items: [
            ..._config.value.columns
              .filter((c) => c.jsPath)
              // @ts-ignore
              .map((c) => pluck("key", "name", "jsPath")(c)),
          ],
          position: "bottom",
          event,
          width: remToPx(25),
        });
        if (res.type === "success") {
          const { fileName, keys } = res.action;
          emit("csv", {
            fileName: fileName + ".csv",
            mapping: toRecord(
              keys as Array<{ name: string; jsPath: string }>,
              "name",
              "jsPath"
            ),
          });
          AppAnalytics.report({
            component: "General",
            eventName: `Export_clicked[Area:${$route.name}]`,
          });
        }
      }
    };

    const updateWidth = () => {
      if (theTable.value) {
        theTable.value.style.maxWidth = "auto";
      }
      setTableWidth();
    };

    const setTableWidth = debounce(200)(() => {
      if (props.keepConstWidth && theTable.value) {
        const { width } = getComputedStyle(theTable.value);
        theTable.value.style.maxWidth = width;
      }
    });

    const subs = {
      resize: emptyFn(),
      respositionWatcher: emptyFn(),
    };

    onMounted(() => {
      if (props.keepConstWidth) {
        setTableWidth();
        window.addEventListener("resize", updateWidth);
        subs.resize = () => window.removeEventListener("resize", updateWidth);
      }

      subs.respositionWatcher = watch(
        _config,
        () => {
          reposition();
        },
        {
          deep: true,
        }
      );
    });

    onBeforeUnmount(() => Object.values(subs).forEach((unsub) => unsub()));

    const scrollToTop = () => {
      if (psb.value && (psb.value as any).$el) {
        (psb.value as any).$el.scrollTop = 0;
      }
    };

    return {
      showNoResults,
      theTable,
      isSummaryOpen,
      psb,
      tableRow,
      keys,
      displayItems,
      gridCols,
      sort,
      minTableWidth,
      loadMore,
      reposition,
      exportAsCsv,
      scrollToTop,
    };
  },
});
